import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSwirl = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.1406 7.84875C28.3468 16.0044 35.5824 24.9138 36.9627 32.2741M36.9627 32.2741C39.1343 43.8539 26.8131 51.5994 19.9182 46.5438C10.1362 39.3712 22.8774 25.6002 36.9627 32.2741ZM36.9627 32.2741C43.1757 35.218 49.6502 42.1396 54.5686 55.36M56.5908 46.0633L54.8883 55.9144L45.4307 51.7887",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
const ForwardRef = forwardRef(SvgSwirl);
export default ForwardRef;
